import { useState, useEffect } from 'react';

export const useRadioGroup = ({options, optionsChecked, onChange: setOptionChecked}) => {
  const optionsCheckedId = optionsChecked.length ? optionsChecked[0] : null;
  const [ optionId, setOptionId ] = useState(optionsCheckedId);

  const makeToChecked = (optionId) => {
    return options.map(option => ({
      ...option,
      isChecked: option.id === optionId
    }));
  };

  const onChangeOptionId = (optionId) => {
    const optionChecked = makeToChecked(optionId);

    setOptionId(optionId);
    setOptionChecked(optionChecked);
  };

  const onChangeSelectValue = (value, { id }) => {
    const optionsChecked = makeToChecked(optionId);
    const options = optionsChecked.map((option) => {
      return {
        ...option,
        ...(option.id === id ? {selectValue: value} : {})
      }
    });

    setOptionChecked(options);
  };

  useEffect(() => {
    if (optionsCheckedId) {
      const optionChecked = makeToChecked(optionsCheckedId);

      setOptionChecked(optionChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    optionId,
    onChangeOptionId,
    onChangeSelectValue
  ]
};
